import { Provider } from "@angular/core";
import { DmpServiceAbstract } from './dmp-service.abstract';
import { environment } from 'src/environments/environment';
import { DmpMockService } from "./dmp-mock.service";
import { CpxHandleServiceAbstract } from "../cpx-handle/cpx-handle-service-abstract";
import { DmpWebSocketStrategyService } from "./strategies/dmp-websocket.strategy";
import { DmpRestStrategyService } from "./strategies/dmp-rest.strategy";
import { ProfilService } from "../profil/profil.service";

const dmpServiceAbstract = (
  profilSrv: ProfilService,
  cpxHandleSrv: CpxHandleServiceAbstract,
  dmpWebSocketSrv: DmpWebSocketStrategyService,
  dmpRestSrv: DmpRestStrategyService,
  dmpMockSrv: DmpMockService
) => {
  const getStrategy = async (): Promise<DmpServiceAbstract> => {
    if (environment.dmpMock) {
      return dmpMockSrv;
    }
    const useRest = await profilSrv.useEdcRestProxy();
    console.log('USE REST API : ', useRest);
    return useRest ? dmpRestSrv : dmpWebSocketSrv;
  };

  return new Proxy(dmpWebSocketSrv, {
    get(target, prop) {
      // Pour les appels de méthodes
      if (typeof (target as any)[prop] === 'function') {
        return async (...args: any[]) => {
          const strategy = await getStrategy();
          return (strategy as any)[prop](...args);
        };
      }

      // Pour les propriétés synchrones
      const activeStrategy = environment.dmpMock ? dmpMockSrv : dmpWebSocketSrv;
      return (activeStrategy as any)[prop];
    },
    set(target, prop, value) {
      // Synchronisation des propriétés sur l'ensemble des stratégies
      (dmpWebSocketSrv as any)[prop] = value;
      (dmpRestSrv as any)[prop] = value;
      (dmpMockSrv as any)[prop] = value;
      return true;
    }
  });
};

export const dmpServiceProvider: Provider[] = [
  {
    provide: DmpServiceAbstract,
    useFactory: dmpServiceAbstract,
    deps: [
      ProfilService,
      CpxHandleServiceAbstract,
      DmpWebSocketStrategyService,
      DmpRestStrategyService,
      DmpMockService
    ]
  }
];
